import { createSelector } from 'reselect';

import { getTabName } from '~/utils/filterGroups';

import { type ApplicationState } from '../store';
import { getNotEmptyOrdersFilters, getOrderFiltersValues, getQSSaved } from './router.selectors';

const getFiltersStore = (state: ApplicationState) => state.filters;

export const getShowNewTab = createSelector(
  getFiltersStore,
  (filtersStore) => filtersStore.showNewTab,
);

export const getCurrentFilterGroups = createSelector(
  getFiltersStore,
  (filtersStore) => filtersStore.filterGroups,
);

export const getSelectedTab = createSelector(
  getQSSaved,
  getNotEmptyOrdersFilters,
  getOrderFiltersValues,
  getCurrentFilterGroups,
  (savedTabName, notEmptyOrdersFilters, orderFiltersValues, currentFilterGroups) =>
    getTabName(notEmptyOrdersFilters, orderFiltersValues, savedTabName, currentFilterGroups),
);

export const getTempFilters = createSelector(
  getFiltersStore,
  (filtersStore) => filtersStore.tempFilterGroup,
);
